import { isBrowser } from '../env';
export const getDatadogLogs = async () => {
    if (!isBrowser()) {
        throw new Error('Datadog Logs is only available in the browser');
    }
    if (window?.DD_LOGS?.getInitConfiguration()) {
        return window.DD_LOGS;
    }
    const { datadogLogs } = await import('@datadog/browser-logs');
    return datadogLogs;
};
